module.exports = __webpack_public_path__ + "img/map_area2_active.b52cdbc0.png";